import { EventEmitter } from "events";

const songEvents = new EventEmitter();

export default songEvents;
